/**
 *
 */
class AlignmentMode
{
	/**
	 *
	 */
	public static REGISTRATION_POINT:string = "registrationPoint";

	/**
	 *
	 */
	public static PIVOT_POINT:string = "pivot";
}

export default AlignmentMode;